import { v4 as uuidv4 } from 'uuid';
export const Options = {
    body: {
        id: [],
        key: [],
        createdAt: [],
        showClient: []
    },
    refs: {
        props: '[eventProp]'
    },
    defs: {
        id: () => uuidv4(),
        createdAt: () => Date.now(),
        showClient: () => true
    },
    list: {
        key: model => model.id
    }
};
